import { render } from "./Index.vue?vue&type=template&id=6af1959e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6af1959e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6af1959e"

export default script